import React from 'react';
import PropTypes from 'prop-types';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DateService } from '../../../../../services/date-service';
import moment from 'moment';
import { twelveHourUserSettingForBrandedEmail, twelveHourUserSetting } from '../../../../../constants/timezone-format';

const formatTime = (time, timeFormat) => DateService.extractTime(moment().utc().set(time).toDate(), timeFormat);

const getTimes = (timeFormat) => {
  const times = [];
  let hour;
  let minute;

  for (hour = 0; hour < 24; hour++) {
    for (minute = 0; minute < 60; minute += 15) {
      const t = {
        hour,
        minute,
        second: 0,
        millisecond: 0,
      };
      const timeActualValue = formatTime(t, twelveHourUserSettingForBrandedEmail).toUpperCase();
      const timeDisplayValue = formatTime(t, timeFormat).toUpperCase();
      const timeObject = {
        value: timeActualValue,
        display: timeDisplayValue,
      };
      times.push(timeObject);
    }
  }
  return times;
};

const defaultTimeFormat = DateService.getDefaultTimeFormat();

const TimePicker = ({
  className = null,
  onTimeSelected = null,
  disabled = false,
  selectedValue = '12:00AM',
  timeFormat = defaultTimeFormat,
  id,
  togglerClassName = '',
}) => {
  const formatToUse = timeFormat === twelveHourUserSetting ? twelveHourUserSettingForBrandedEmail : timeFormat;
  const times = getTimes(formatToUse);
  const selectedTime = times.find((t) => t.value === selectedValue);

  return (
    <DropdownMenu className={className} disabled={disabled} dropdownMenuShouldHaveWidthOfButton id={id} variant='form'>
      <DropdownMenuToggler className={togglerClassName} title={selectedTime?.display}>
        {selectedTime?.display}
      </DropdownMenuToggler>
      {times.map((time) => (
        <DropdownMenuItem key={time.value} onClick={() => onTimeSelected(id, time.value)}>
          {time.display}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

TimePicker.propTypes = {
  className: PropTypes.string,
  timeFormat: PropTypes.string,
  disabled: PropTypes.bool,
  onTimeSelected: PropTypes.func,
  selectedValue: PropTypes.string,
  id: PropTypes.string.isRequired,
  togglerClassName: PropTypes.string,
};

export default TimePicker;
